import React, { Component } from 'react';
import {Card, CardHeader, CardBody, Table } from 'reactstrap';
import { connect } from "react-redux";
import { BarLoader } from 'react-spinners';
import {Gmaps, Marker, InfoWindow, Circle} from 'react-gmaps';
import moment from 'moment'
import { fetchTransporterShareTrack } from '../../../redux/actions/aTransporter-ShareTracker.jsx'
import customMarker from '../../../assets/img/truck.png'

const params = {
    v: '3.exp', 
    key: 'AIzaSyCmIATqobqbCEU90nYtwd-PzCcj8EVOlDg'
  };

class Tracker extends Component {
    componentWillMount = () => {
        this.props.fetchTransporterShareTrack(this.props.match.params.id)
    }
    onMapCreated(map) {
        map.setOptions({
          disableDefaultUI: false
        });
    }

    dateFormatter = (_data) => {
        var date = moment(_data).format("DD-MMM-YYYY HH:mm:ss");
        if(date !== "Invalid date"){
            return date
        }
        else {
            return "Time limit exceeded"
        }
    }


    renderTrackerLog = () => {
        console.log(this.props.transporterShareTrackData)
        if(this.props.transporterShareTrackData !== "" || this.props.transporterShareTrackData !== [] || this.props.transporterShareTrackData !== null){

            return this.props.transporterShareTrackData.map(data => {
                if(data.kampret_condition === true){
                    console.log("render marker")
                    return(
                        <Card>
                            <Gmaps
                                width="100%"
                                height="20vw"
                                lat={data.fleet_status.lat}
                                lng={data.fleet_status.lon}
                                zoom={16}
                                loadingMessage={"Please wait while we're preparing this for you..."}
                                params={params}
                                onMapCreated={this.onMapCreated}>
                                    {/* For Truck Position */}
                                <Marker
                                    options={{icon: customMarker}}
                                    lat={data.fleet_status.lat}
                                    lng={data.fleet_status.lon}
                                    draggable={true}
                                    onDragEnd={this.onDragEnd}
                                />
                                <InfoWindow
                                    lat={data.fleet_status.lat+0.0008}
                                    lng={data.fleet_status.lon}
                                    content={"<strong>Fleet Location<br/>Lat: </strong>"+data.fleet_status.lat+"<strong>,<br/> Long: </strong>"+data.fleet_status.lon}
                                    onCloseClick={this.onCloseClick}
                                />
                                <Circle
                                    lat={data.fleet_status.lat}
                                    lng={data.fleet_status.lon}
                                    radius={100}
                                    // onClick={this.onClick}
                                />
                                    {/* For Warehouse Position */}
                                <Marker
                                    lat={data.result[0].work_order_from.lat}
                                    lng={data.result[0].work_order_from.lng}
                                    draggable={true}
                                    onDragEnd={this.onDragEnd}
                                />         
                            </Gmaps>
    
                            
                            <div className="fleet-mondtl-container">
                                <div className="fleet-mondtl-table">
                                    <Table responsive striped>
                                        <tbody>
                                            <tr>
                                                <td><h6>WO Number</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.wo_number}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>WO Seq</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.wo_seq}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>WO Desc</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.wo_desc}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>WO Destination Name</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.wo_destination_name}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>WO Address</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.wo_address}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="fleet-mondtl-table">
                                    <Table responsive striped>
                                        <tbody>
                                            <tr>
                                                <td><h6>PIC Name</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.pic_name}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>PIC Phone</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.pic_phone}</td>
                                            </tr>
                                            
                                            {/* <tr>
                                                <td><h6>Location Name</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.work_order_from.loc_name}</td>
                                            </tr> */}
                                            <tr>
                                                <td colSpan="3"><center>Your Fleet Location</center></td>
                                            </tr>
                                            
                                            <tr>
                                                <td><h6>Latitude</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.fleet_status.lat}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>Longitude</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.fleet_status.lon}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="fleet-mondtl-table">
                                    <Table responsive striped>
                                        <tbody>
                                            <tr>
                                                <td><h6>Distance</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{data.result[0].work_order_from.distance} KM</td>
                                            </tr>
                                            <tr>
                                                <td><h6>Est. Departure Time</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{this.dateFormatter(data.result[0].work_order_from.est_departure_time)}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>Est. Arrival Time</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{this.dateFormatter(data.result[0].work_order_from.est_arrival_time)}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>Check In Time</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{this.dateFormatter(data.result[0].timeCheckIn)}</td>
                                            </tr>
                                            <tr>
                                                <td><h6>Check Out Time</h6></td>
                                                <td>&nbsp;</td>
                                                <td>{this.dateFormatter(data.result[0].timeCheckOut)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                {/* Check In Details */}
                                <div className="report-dodetails-table">
                                    <Table responsive borderless>
                                        <tbody>
                                            <tr>
                                                <td><h6>Distance from Check In Location</h6></td>
                                                <td>&nbsp;</td>
                                                <td><h6>{data.result[0].meterToCheckIn} M</h6></td>
                                            </tr>
                                            <tr>
                                                <td><h6>Loading Time</h6></td>
                                                <td>&nbsp;</td>
                                                <td><h6>{data.result[0].loadingTime}</h6></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                    </Card>
                    )
                }
                else if(data.kampret_condition === false){
                    console.log("render circle")
                    if(data.result[0].timeCheckIn !== null || data.result[0].timeCheckOut !== null){
                        return(
                            <Card>
                                <Gmaps
                                    width="100%"
                                    height="20vw"
                                    lat={data.fleet_status.lat}
                                    lng={data.fleet_status.lon}
                                    zoom={16}
                                    loadingMessage={"Please wait while we're preparing this for you..."}
                                    params={params}
                                    onMapCreated={this.onMapCreated}>
                                        {/* For Truck Position */}
                                    <Marker
                                        options={{icon: customMarker}}
                                        lat={data.fleet_status.lat}
                                        lng={data.fleet_status.lon}
                                        draggable={true}
                                        onDragEnd={this.onDragEnd}
                                    />
                                    <InfoWindow
                                        lat={data.fleet_status.lat+0.0008}
                                        lng={data.fleet_status.lon}
                                        content={"<strong>Delivery finished.<br/> Location<br/>Lat: </strong>"+data.fleet_status.lat+"<strong>,<br/> Long: </strong>"+data.fleet_status.lon}
                                        onCloseClick={this.onCloseClick}
                                    />
                                    <Circle
                                        lat={data.fleet_status.lat}
                                        lng={data.fleet_status.lon}
                                        radius={100}
                                        // onClick={this.onClick}
                                    />
                                        {/* For Warehouse Position */}
                                    <Marker
                                        lat={data.result[0].work_order_from.lat}
                                        lng={data.result[0].work_order_from.lng}
                                        draggable={true}
                                        onDragEnd={this.onDragEnd}
                                    />         
                                </Gmaps>
        
                                
                                <div className="fleet-mondtl-container">
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>WO Number</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_number}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Seq</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_seq}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Desc</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_desc}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Destination Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_destination_name}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Address</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_address}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>PIC Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.pic_name}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>PIC Phone</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.pic_phone}</td>
                                                </tr>
                                                
                                                {/* <tr>
                                                    <td><h6>Location Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.work_order_from.loc_name}</td>
                                                </tr> */}
                                                <tr>
                                                    <td colSpan="3"><center>Your Fleet Location</center></td>
                                                </tr>
                                                
                                                <tr>
                                                    <td><h6>Latitude</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.fleet_status.lat}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Longitude</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.fleet_status.lon}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>Distance</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.distance} KM</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Est. Departure Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].work_order_from.est_departure_time)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Est. Arrival Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].work_order_from.est_arrival_time)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Check In Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].timeCheckIn)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Check Out Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].timeCheckOut)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    {/* Check In Details */}
                                    <div className="report-dodetails-table">
                                        <Table responsive borderless>
                                            <tbody>
                                                <tr>
                                                    <td><h6>Distance from Check In Location</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td><h6>{data.result[0].meterToCheckIn} M</h6></td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Loading Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td><h6>{data.result[0].loadingTime}</h6></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                        </Card>
                        )
                    } else{
                        console.log("delivery ongoing")
                        return(
                            <Card>
                                <Gmaps
                                    width="100%"
                                    height="20vw"
                                    lat={data.fleet_status.lat}
                                    lng={data.fleet_status.lon}
                                    zoom={16}
                                    loadingMessage={"Please wait while we're preparing this for you..."}
                                    params={params}
                                    onMapCreated={this.onMapCreated}>
                                        {/* For Truck Position */}
                                    <Circle
                                        lat={data.fleet_status.lat}
                                        lng={data.fleet_status.lon}
                                        radius={12500}
                                    />

                                        {/* For Warehouse Position */}
                                    <Marker
                                        lat={data.result[0].work_order_from.lat}
                                        lng={data.result[0].work_order_from.lng}
                                        draggable={true}
                                        onDragEnd={this.onDragEnd}
                                    />
                                    <InfoWindow
                                        lat={data.result[0].work_order_from.lat+0.0008}
                                        lng={data.result[0].work_order_from.lng}
                                        content={"<strong>Warehouse Location<br/>Lat: </strong>"+data.result[0].work_order_from.lat+"<strong>,<br/> Long: </strong>"+data.result[0].work_order_from.lng}
                                        onCloseClick={this.onCloseClick}
                                    />     
                                    
                                </Gmaps>
        
                                
                                <div className="fleet-mondtl-container">
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>WO Number</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_number}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Seq</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_seq}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Desc</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_desc}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Destination Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_destination_name}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>WO Address</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.wo_address}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>PIC Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.pic_name}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>PIC Phone</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.pic_phone}</td>
                                                </tr>
                                                
                                                {/* <tr>
                                                    <td><h6>Location Name</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.work_order_from.loc_name}</td>
                                                </tr> */}
                                                <tr>
                                                    <td colSpan="3"><center>Your Fleet Location</center></td>
                                                </tr>
                                                
                                                <tr>
                                                    <td><h6>Latitude</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.fleet_status.lat}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Longitude</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.fleet_status.lon}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="fleet-mondtl-table">
                                        <Table responsive striped>
                                            <tbody>
                                                <tr>
                                                    <td><h6>Distance</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{data.result[0].work_order_from.distance} KM</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Est. Departure Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].work_order_from.est_departure_time)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Est. Arrival Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].work_order_from.est_arrival_time)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Check In Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].timeCheckIn)}</td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Check Out Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td>{this.dateFormatter(data.result[0].timeCheckOut)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    {/* Check In Details */}
                                    <div className="report-dodetails-table">
                                        <Table responsive borderless>
                                            <tbody>
                                                <tr>
                                                    <td><h6>Distance from Check In Location</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td><h6>{data.result[0].meterToCheckIn} M</h6></td>
                                                </tr>
                                                <tr>
                                                    <td><h6>Loading Time</h6></td>
                                                    <td>&nbsp;</td>
                                                    <td><h6>{data.result[0].loadingTime}</h6></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                        </Card>
                        )
                    }
                    
                }
            })
        } else {
            return (
                <Card>
                    <center><h6>There is no data to display!</h6></center>
                </Card>
            )
        }  
    }

    render(){
        return(
            
            <div className="fleet-mondtl-container">
                <Card>
                    <CardHeader>
                        <h4>Automa Transporter Tracker</h4>
                    </CardHeader>
                    <br/>
                    <CardBody>
                        {this.props.inProgress ? <center><BarLoader color={'#123abc'} 
                        loading={this.props.inProgress} 
                        /> <br /> Loading.... Please wait...</center> : this.renderTrackerLog()}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        transporterShareTrackData: state.transporterShareTrackStore.transporterShareTrackData,
        inProgress: state.transporterShareTrackStore.inProgress,
      }
}

export default connect(mapStateToProps, {fetchTransporterShareTrack}) (Tracker)


// WEBPACK FOOTER //
// ./src/views/Transporter/Tracker/Tracker.jsx